import type { AccountingReportPartTypeEnum } from '@/generated/graphql';
export interface IUserLogin {
  login: string;
  password?: string;
  lang?: string;
}

export interface ICookiesOptions {
  path?: string;
  domain?: string;
  secure?: boolean;
  'max-age'?: number;
  expires?: string;
  sameSite?: string;
}

export interface ILoginData {
  email?: string;
  password?: string;
}

export type FileExtension = 'pdf' | 'doc' | 'docx' | 'xlsx' | 'png' | 'jpeg' | 'jpg';

export enum FileEnumAccounting {
  AccountingFileType = 'AccountingFileType',
  ContractsFileType = 'ContractsFileType',
  TransferFileType = 'TransferFileType',
}

export type typeFileAccounting =
  | FileEnumAccounting.ContractsFileType
  | FileEnumAccounting.AccountingFileType;
export type typesSubfoldersForQuickMove =
  | AccountingReportPartTypeEnum.Incoming
  | AccountingReportPartTypeEnum.Outgoing;

export enum FileActions {
  Download = 'download',
  DownloadArchive = 'downloadArchive',
  Move = 'move',
  Rename = 'rename',
  HardDelete = 'hardDelete',
  QuickMove = 'quickMove',
  Upload = 'upload',
  OpenFolder = 'openFolder',
  View = 'view',
  ToggleReadStatus = 'toggleReadStatus',
  DeleteContractFile = 'deleteContractFile',
  ConfirmFile = 'ConfirmFile',
  DenyFile = 'DenyFile',
  SendToMerit = 'sendToMerit',
  CreateTicket = 'createTicket'
}

export interface FileInfo {
  id: string;
  ownerId: string;
  companyId: string | null;
  sourceType: string | null;
  size: number;
  mimeType: string;
  name: string;
  downloadAt: string;
  createdAt: string;
  updatedAt: string;
}

export enum EventBusEvents {
  changedContractFiles = 'changed-contract-files',
  changedAccountingFiles = 'changed-accounting-files',
  companyAccountantAssigned = 'company-accountant-assigned',
  companyAccountantUnassigned = 'company-accountant-unassigned',
  renamedFileAccounting = 'renamed-file',
  requestFileConfirmation = 'requestFileConfirmation',
  fileStatusUpdatedInViewer = 'fileStatusUpdatedInViewer',
  periodStatusUpdated = 'periodStatusUpdated',
  updateTransferFiles = 'updateTransferFiles',
}

export interface IFirmCompaniesFilters {
  search?: string | null;
  accountantId?: string,
  /** undefined — all companies, true — only autopilot clients, false — only those without it */
  isAutopilotClient?: boolean;
}

export interface ICompaniesFilters {
  selectedMarketId?: number | null;
  companyName?: string | null;
  /** undefined — all companies, true — only autopilot clients, false — only those without it */
  isAutopilotClient?: boolean;
  /** undefined — all companies, otherwise only those assigned to this accountant */
  accountantId?: string;
  /** true — only companies no accountant is assigned to */
  withoutAccountant?: boolean;
}

export interface IFileData {
  fileId: string;
  newFileName: string;
}

export interface IPaginationDocuments {
  sortBy: string | null;
  descending: boolean;
  page: number;
  rowsPerPage: number;
  rowsNumber: number;
}
